/* @ngInject */
const myAxletreesEditForm = (
  toaster,
  utils,
  $$axletree,
  labels
) => {
  return {
    restrict: 'E',
    scope: {
      myAxletrees: '=',
      myWagonId: '=',
      defaultWeight: '=',
    },
    template: require('./myAxletreesEditForm.html'),
    /* @ngInject */
    controller: ($scope) => {
      $scope.saveAxletrees = async (_axletrees) => {
        try {
          const response = await $$axletree.request.saveAll(_axletrees, $scope.myWagonId)
          toaster.message(labels.axletree.log.saveAll.success(response.length))
          utils.$back()
        } catch (error) {
          toaster.error(error)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}
export default myAxletreesEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/axletree/directives/forms/myAxletreesEditForm.js